// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2uu5e","column":"style_column__3POs3","row":"style_row__sqHAA"};